import { z } from "zod";
import {
  CLOSING_CONTACT_EMAIL,
  CLOSING_CONTACT_NAME,
  CLOSING_CONTACT_PHONE,
  CLOSING_CONTACT_SOURCE,
  COMMUNITY,
  PAL_NEEDED_BY_DATE,
  PROPERTY_ID,
  RECEIPT_DATE,
  RECEIPT_FROM,
  REPORTER_EMAIL, 
  REPORTER_NAME,
  REPORTER_PHONE,
  REPORTER_TITLE,
  SELLER_EMAIL,
  SELLER_NAME,
  SELLER_PHONE, 
  TARGET_CLOSING_DATE,
  OCP_ID,
  STATUS,
  OWNER,
  OWNER_ID,
  PROOF_FILE,
 } from "../../consts";

 const requiredDateValidation = z.coerce.date({
  required_error: "This field is required",
  invalid_type_error: "This field is required",
});

const optionalPhone = z
.string()
.regex(/^\+[1-9][0-9]{6,14}$/, "Invalid Phone Number")
.or(z.literal(""))
.optional();

export const schema = z.object({
  [OCP_ID]: z.string().optional(),
  [COMMUNITY]: z.string().optional(),
  [OWNER]: z.string().optional(),
  [OWNER_ID]: z.string().optional(),
  [PROPERTY_ID]: z.string().min(1, "This field is required."),
  [RECEIPT_DATE]: requiredDateValidation,
  [RECEIPT_FROM]: z.string().min(1, "This field is required."),
  [REPORTER_NAME]: z.string().min(1, "This field is required."),
  [REPORTER_TITLE]: z.string().optional(),
  [REPORTER_EMAIL]: z.string().optional(),
  [REPORTER_PHONE]: optionalPhone,
  [SELLER_NAME]: z.string().optional(),
  [SELLER_EMAIL]: z.string().optional(),
  [SELLER_PHONE]: optionalPhone,
  [TARGET_CLOSING_DATE]: requiredDateValidation,
  [PAL_NEEDED_BY_DATE]: requiredDateValidation,
  [CLOSING_CONTACT_SOURCE]: z.string().optional(),
  [CLOSING_CONTACT_NAME]: z.string().optional(),
  [CLOSING_CONTACT_EMAIL]: z.string().optional(),
  [CLOSING_CONTACT_PHONE]: optionalPhone,
  [PROOF_FILE]: z.any().optional(),
  [STATUS]: z.string().optional(),
});


export type formValues = z.infer<typeof schema>;
